<script setup lang="ts">
import { ref, inject, Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { handleBeforeSendImage, handleSelectFile as handleSelectFileExcel } from '@/utils/helper';
import { useToast } from 'primevue/usetoast';
import Button from 'primevue/button';
import FileUpload from 'primevue/fileupload';

const dialogRef = inject('dialogRef') as Ref;
const onApply = dialogRef?.value?.options?.emits?.onApply;
const onClose = dialogRef?.value?.options?.emits?.onClose;
const url = dialogRef?.value?.options?.data.url;

const { t } = useI18n({ useScope: 'global' });
const toast = useToast();
const fileData = ref<any>([]);
const fileUploaded = ref<any>();
const fileUpload = ref();
const isDisable = ref(false);

const onClickApply = (data: any, file: any) => {
  onApply(data, file);
};

const handleSelectFile = () => {
  handleSelectFileExcel();
};

const onCancel = () => {
  onClose();
  fileData.value = [];
  fileUpload.value.uploadedFileCount = 0;
};

const handleRemoveFile = () => {
  fileData.value = [];
  fileUpload.value.uploadedFileCount = 0;
  isDisable.value = false;
};

const onAdvancedUpload = (res: any) => {
  const response = JSON.parse(res.xhr?.response);
  fileData.value = response;
  fileUploaded.value = res?.files?.[0];
  isDisable.value = true;
};

const uploadEvent = (callback: any) => {
  isDisable.value = true;
  callback();
};

const handleError = (error: any) => {
  if (error.xhr?.response) {
    toast.add({ severity: 'error', summary: '', detail: t('notification.import_error') });
  }
};
</script>
<template>
  <div class="text-center import-modal">
    <FileUpload
      name="file"
      @before-send="handleBeforeSendImage"
      @select="handleSelectFile()"
      @error="handleError($event)"
      :withCredentials="true"
      ref="fileUpload"
      id="file_upload"
      :url="url"
      @removeUploadedFile="handleRemoveFile()"
      @upload="onAdvancedUpload($event)"
      accept=".xlsx,.xls,.pdf,.docx,.doc,.txt,.csv"
      :maxFileSize="5000000"
      :file-limit="1"
      :invalid-file-size-message="$t('notification.validSizeImg')"
    >
      <template #empty>
        <p>{{ $t('promos.labels.drag_file_desc') }}</p>
      </template>
      <template> </template>
      <template #header="{ chooseCallback, uploadCallback, clearCallback, files }">
        <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
          <div class="flex gap-2">
            <Button :disabled="isDisable || files.length !== 0" :label="$t('promos.labels.choose')" @click="chooseCallback()" icon="pi pi-plus" />
            <Button :disabled="!files || files.length === 0" :label="$t('promos.labels.upload')" @click="uploadEvent(uploadCallback)" icon="pi pi-upload"></Button>
            <Button :disabled="!files || files.length === 0" :label="$t('promos.labels.cancel')" @click="clearCallback()" icon="pi pi-times"></Button>
          </div>
        </div>
      </template>
    </FileUpload>

    <div class="mt-3 text-left">
      <Button class="mr-2" :disabled="!(fileData?.length > 0)" :label="$t('common.buttons.save')" @click="onClickApply(fileData, fileUploaded)" data-testid="btn_submit" />
      <Button :label="$t('common.buttons.cancel')" @click="onCancel()" data-testid="btn_cancel" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.import-modal {
  min-width: 38rem;
}
:deep() {
  .p-fileupload-file-thumbnail {
    display: none;
  }
}
</style>
